import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import axios from "axios";
import { Map, View } from "ol";
import { fromLonLat } from "ol/proj";
import { OSM, Cluster, Vector as VectorSource } from "ol/source";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import { Feature } from "ol";
import { Point } from "ol/geom";
import { Style, Icon, Text, Fill, Stroke, Circle as CircleStyle } from "ol/style";
import "ol/ol.css";

// img
import img from '../assets/img.png';
import img2 from '../assets/img2.png';
import img3 from '../assets/img3.png';
import img4 from '../assets/img.jpg';
import j288 from '../assets/j_288.jpg';
import j289 from '../assets/j_289.jpg';
import j290 from '../assets/j_290.jpg';
import j311 from '../assets/j_311.jpg';
import j314 from '../assets/j_314.jpg';
import Header from '../components/Header';
import Footer from '../components/Footer';
import LocalKrpano from './LocalKrpano';
import AreaMap from './AreaMap';


const API_KEY = "ed022e7b0e7cea4d8a220179896bb796"; // 여기에 OpenWeather API 키 입력
const KAKAO_API_KEY = '0c487e3694898026a919673090046bd1';

const LocalInformationPage = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedDistrict, setSelectedDistrict] = useState('강남구'); // 초기값 설정
  const [currentImage, setCurrentImage] = useState(j290); // 초기 이미지 설정
  const [weather, setWeather] = useState(null); // 날씨 상태 추가
  const [restaurants, setRestaurants] = useState([]);
  const [sightseeing, setSightseeing] = useState([]);
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupContent, setPopupContent] = useState(null);
  const mapRef = useRef(null);
  const mapInstanceRef = useRef(null);
  

  const originalAlert = window.alert;
    window.alert = (message) => {
      if (message.includes("ERROR: No Embedding Target")) {
        return; // 특정 메시지는 표시하지 않음
      }
      originalAlert(message); // 다른 메시지는 그대로 실행
    };

  const handleCardClick = (subject) => {
    if (subject === '관광') {
      setPopupContent({
        title: `${selectedDistrict}의 관광명소`,
        data: sightseeing,
      });
    } else if (subject === '음식') {
      setPopupContent({
        title: `${selectedDistrict}의 음식점`,
        data: restaurants,
      });
    }
    setPopupVisible(true);
  };
  const closePopup = () => {
    setPopupVisible(false);
  };

  useEffect(() => {
    const fetchRestaurants = async () => {
      try {
        const response = await axios.get(
          "https://dapi.kakao.com/v2/local/search/keyword.json",
          {
            headers: {
              Authorization: `KakaoAK ${KAKAO_API_KEY}`
            },
            params: {
              query: `${selectedDistrict} 음식점`, // 강남구 음식점 검색
              category_group_code: "FD6", // 음식점 카테고리 코드
              x: "127.0276", // 강남역 좌표 (중심점)
              y: "37.4979", // 강남역 위도
              radius: 5000, // 반경 5km
              page: 1,
              size: 10, // 요청할 음식점 수
            },
          }
        );
        setRestaurants(response.data.documents);
        console.log("음식점 데이터:", response.data.documents);
      } catch (error) {
        console.error("Kakao 음식점 API 호출 오류:", error);
      }
    };
  
    fetchRestaurants();
  }, [selectedDistrict]);

  useEffect(() => {
    const fetchSightseeing = async () => {
      try {
        const response = await axios.get(
          "https://dapi.kakao.com/v2/local/search/keyword.json",
          {
            headers: {
              Authorization: `KakaoAK ${KAKAO_API_KEY}`
            },
            params: {
              query: `${selectedDistrict} 관광`, // 강남구 음식점 검색
              category_group_code: "AT4", // 음식점 카테고리 코드
              x: "127.0276", // 강남역 좌표 (중심점)
              y: "37.4979", // 강남역 위도
              radius: 5000, // 반경 5km
              page: 1,
              size: 10, // 요청할 음식점 수
            },
          }
        );
        setSightseeing(response.data.documents);
        console.log("관광명소 데이터:", response.data.documents);
      } catch (error) {
        console.error("Kakao 관광 명소 API 호출 오류:", error);
      }
    };
  
    fetchSightseeing();
  }, [selectedDistrict]);

   // 🔹 OpenLayers 지도 생성
   useEffect(() => {
    if (!mapInstanceRef.current && sightseeing.length > 0) {
      // 🔸 기본 OSM 타일 레이어
      const baseLayer = new TileLayer({ source: new OSM() });

      // 🔸 관광명소 데이터를 Features로 변환
      const features = sightseeing.map((place) => {
        const feature = new Feature({
          geometry: new Point(fromLonLat([parseFloat(place.x), parseFloat(place.y)])),
          name: place.place_name,
          address: place.address_name,
        });

        

        // 🔸 스타일 지정 (클러스터)
        feature.setStyle(
          new Style({
            image: new CircleStyle({
              radius: 8,
              fill: new Fill({ color: "#ff5722" }),
              stroke: new Stroke({ color: "#ffffff", width: 2 }),
            }),
            text: new Text({
              text: place.place_name,
              offsetY: -15,
              font: "12px Arial",
              fill: new Fill({ color: "#333" }),
              stroke: new Stroke({ color: "#fff", width: 2 }),
            }),
          })
        );

        return feature;
      });

      // 🔹 벡터 소스 & 클러스터 설정
      const vectorSource = new VectorSource({ features });
      const clusterSource = new Cluster({ distance: 40, source: vectorSource });

      // 🔹 클러스터 레이어
      const clusterLayer = new VectorLayer({
        source: clusterSource,
        style: (feature) => {
          const size = feature.get("features").length;
          return new Style({
            image: new CircleStyle({
              radius: size > 1 ? 12 : 8,
              fill: new Fill({ color: size > 1 ? "#ff9800" : "#ff5722" }),
              stroke: new Stroke({ color: "#fff", width: 2 }),
            }),
            text: new Text({
              text: size.toString(),
              font: "14px Arial",
              fill: new Fill({ color: "#fff" }),
            }),
          });
        },
      });

      // 🔸 OpenLayers 지도 인스턴스 생성
      const map = new Map({
        target: mapRef.current,
        layers: [baseLayer, clusterLayer],
        view: new View({
          center: fromLonLat([127.0276, 37.4979]), // 기본 위치
          zoom: 13,
        }),
      });

      mapInstanceRef.current = map;
    }
  }, [sightseeing]);




  const districts = [
    '종로구', '중구', '용산구', '성동구', '광진구',
    '동대문구', '중랑구', '성북구', '강북구', '도봉구',
    '노원구', '은평구', '서대문구', '마포구', '양천구',
    '강서구', '구로구', '금천구', '영등포구', '동작구',
    '관악구', '서초구', '강남구', '송파구', '강동구', '마린시티','부산벡스코'
  ];

  const tabImages = {
    강남구: j288,
    서초구: j290,
    마린시티: j314,
    부산벡스코: j314,
    광진구: j311,
    관악구: j314,
  };


  // 구별 좌표 (서울 기준) - OpenWeather는 좌표 기반 검색 필요
  const districtCoordinates = {
    종로구: { lat: 37.5729503, lon: 126.9793579 },
    중구: { lat: 37.563617, lon: 126.997694 },
    용산구: { lat: 37.532600, lon: 126.990673 },
    성동구: { lat: 37.563341, lon: 127.036215 },
    광진구: { lat: 37.538484, lon: 127.082293 },
    서초구: { lat: 37.483577, lon: 127.03261 },
    마포구: { lat: 37.566349, lon: 126.90176 },
    강남구: { lat: 37.517236, lon: 127.047325 },
    관악구: { lat: 37.478406, lon: 126.951613 },
  };

  // OpenWeather API 호출 함수
  const fetchWeather = async (district) => {
    if (!districtCoordinates[district]) return;

    const { lat, lon } = districtCoordinates[district];

    try {
      const response = await fetch(
        `https://api.openweathermap.org/data/2.5/weather?lat=${lat}&lon=${lon}&appid=${API_KEY}&units=metric&lang=kr`
      );
      const data = await response.json();

      setWeather({
        temp: data.main.temp,
        description: data.weather[0].description,
        icon: `https://openweathermap.org/img/wn/${data.weather[0].icon}.png`,
      });
    } catch (error) {
      console.error("날씨 정보를 가져오는 데 실패했습니다.", error);
    }
  };

  // selectedDistrict 변경 시 날씨 업데이트
  useEffect(() => {
    fetchWeather(selectedDistrict);
  }, [selectedDistrict]);

  const handleDistrictClick = (district) => {
    if (!tabImages[district]) return; // 선택 불가능한 구는 클릭 무시
    setSelectedDistrict(district);
    setCurrentImage(tabImages[district]); // 구에 맞는 이미지 설정
    setIsOpen(false); // 선택 후 드롭다운 닫기
  };

  const handleTabClick = (district) => {
    setSelectedDistrict(district); // 선택된 구 업데이트
    setCurrentImage(tabImages[district]); // 구에 맞는 이미지 설정
  };
  

  return (
    <>
      <Header />
      <LocalKrpano selectedDistrict={selectedDistrict}/>

      <MainContainer>
        {/* Scrollable tabs section */}
        <ScrollableTabs>
          {Object.keys(tabImages).map((district) => (
            <Tab
              key={district}
              isSelected={selectedDistrict === district}
              onClick={() => handleTabClick(district)}
            >
              {district}
            </Tab>
          ))}
        </ScrollableTabs>

        {/* Toggle button and collapsible section */}
        <ToggleContainer>
          <ToggleButton onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? `${selectedDistrict} ▲` : `${selectedDistrict} ▼`}
          </ToggleButton>
        </ToggleContainer>
        <CollapsibleSection isOpen={isOpen}>
          <Grid>
            {districts.map((district) => (
              <GridItem
                key={district}
                isSelectable={!!tabImages[district]} // 선택 가능 여부 확인
                isSelected={selectedDistrict === district}
                onClick={() => handleDistrictClick(district)}
              >
                {district}
              </GridItem>
            ))}
          </Grid>
        </CollapsibleSection>

     

        {/* Card layout section */}
        <CardGrid>
        <Card onClick={() => handleCardClick('관광')}>
          <CardInfo>
            <Cardsubjects>관광</Cardsubjects>
            <Cardsubtitle>{selectedDistrict}의 <br />역사속으로</Cardsubtitle>
          </CardInfo>
          <CardImg src={img4} />
        </Card>
        <Card onClick={() => handleCardClick('놀이')}>
          <CardInfo>
            <Cardsubjects>놀이</Cardsubjects>
            <Cardsubtitle>{selectedDistrict}의 <br />문화재 탐방</Cardsubtitle>
          </CardInfo>
          <CardImg src={img2} />
        </Card>
        <Card onClick={() => handleCardClick('음식')}>
          <CardInfo>
            <Cardsubjects>음식</Cardsubjects>
            <Cardsubtitle>{selectedDistrict}와 <br />함께하는 음식 탐방</Cardsubtitle>
          </CardInfo>
          <CardImg src={img3} />
        </Card>
      </CardGrid>

      {popupVisible && popupContent && (
        <Popup>
          <PopupContent>
            <PopupTitle>{popupContent.title}</PopupTitle>
            <ul>
            {popupVisible && popupContent && (
        <Popup>
          <PopupContent>
            <PopupTitle>{popupContent.title}</PopupTitle>
            <MapContainer ref={mapRef} />
            
            {/* 🔹 가로 스크롤 가능 카드 리스트 */}
            <ScrollContainer>

              {popupContent.data.map((item) => (
                <InfoCard key={item.id}>
                  <PlaceTitle>{item.place_name}</PlaceTitle>
                  <AddressText>{item.address_name}</AddressText>
                </InfoCard>
              ))}
            </ScrollContainer>
           

            <PopupCloseButton onClick={closePopup}>닫기</PopupCloseButton>
          </PopupContent>
        </Popup>
      )}
            </ul>
            <PopupCloseButton onClick={closePopup}>닫기</PopupCloseButton>
          </PopupContent>
        </Popup>
      )}



        {/* 날씨 정보 표시 */}
        {/* <InfoContainer>
          <WeatherContainer>
          {weather ? (
            <WeatherBox>
              <WeatherIcon src={weather.icon} alt="날씨 아이콘" />
              <WeatherInfo>
                <h3>{selectedDistrict} 날씨</h3>
                <p>{weather.temp}°C</p>
                <p>{weather.description}</p>
              </WeatherInfo>
            </WeatherBox>
          ) : (
            <p>날씨 정보를 불러오는 중...</p>
          )}

          </WeatherContainer>
          <AreaMap selectedDistrict={selectedDistrict} />
         
        </InfoContainer> */}
      </MainContainer>
      <Footer />
    </>
  );
};


export default LocalInformationPage;


const MainContainer = styled.div`
  padding: 20px;
`;

const ScrollableTabs = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 10px;
  padding-bottom: 10px;
  border-bottom: 2px solid #ccc;
  margin-bottom: 20px;

  &::-webkit-scrollbar {
    display: none; /* Hide scrollbar for aesthetics */
  }
`;

const Tab = styled.div`
  min-width:250px;
  height:100px;
  white-space: nowrap;
  font-size: 16px;
  cursor: pointer;
  background: #f0f0f0;
  border-radius: 8px;
  transition: background 0.3s;
  display:flex;
  align-items:center;
  justify-content:center;
  background-color:black;
  color:white;

  &:hover {
    background: #ddd;
  }
`;

const CollapsibleSection = styled.div`
  margin: 20px 0;
  background: #fafafa;
  border: 1px solid #ddd;
  border-radius: 8px;
  transition: max-height 0.3s ease;
  overflow: hidden;
  max-height: ${({ isOpen }) => (isOpen ? '800px' : '0px')};
`;
const ToggleContainer = styled.div`
width:100%;
display:flex;
justify-content:center;
`
const ToggleButton = styled.button`
  background: none;
  border: none;
  font-size: 18px;
  cursor: pointer;
  color: #333;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    color: #007bff;
  }
`;

const CardGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(400px, 1fr));
  gap: 20px;
  justify-content: center; /* 🔹 그리드 아이템들을 가운데 정렬 */
  width: 100%;
  max-width: 1300px; /* 🔹 최대 너비 설정 (원하는 값으로 조정) */
  margin: 0 auto; /* 🔹 좌우 마진을 auto로 설정해 전체 중앙 정렬 */
`;

const Card = styled.div`
  background: #FAF7F0;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  background: #FAF7F0;
  
`;
const CardImg = styled.img `
width:100%;
height:250px;
border-radius:0px 0px 10px 10px;
`;




const CardInfo = styled.div`
width:100%;
background: #FAF7F0;
`


const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 10px;
  margin-top: 10px;
`;

const GridItem = styled.div`
  padding: 10px;
  border-radius:10px;
  background: ${(props) =>
    props.isSelected
      ? '#007bff'
      : props.isSelectable
      ? '#f9f9f9'
      : '#ccc'}; /* 선택 가능 여부에 따라 색상 변경 */
  color: ${(props) =>
    props.isSelected ? 'white' : props.isSelectable ? 'black' : '#666'};
  //border: 1px solid ${(props) => (props.isSelectable ? '#ddd' : '#aaa')};
  text-align: center;
  //cursor: ${(props) => (props.isSelectable ? 'pointer' : 'not-allowed')};
  &:hover {
    background: ${(props) =>
      props.isSelectable
        ? props.isSelected
          ? '#0056b3'
          : '#e9e9e9'
        : '#ccc'};
  }
`;


const InfoContainer = styled.div`
width:100%;
height:300px;
display:flex;
justify-content:space-between;
margin-bottom:20px;

`
const WeatherContainer = styled.div`
width:30%;
height:200px;
background: #FAF7F0;
display: flex;
align-items: center;
justify-content:center;
border-radius:10px;
`
const WeatherBox = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  // background: #f0f0f0;
  padding: 15px;
  border-radius:10px;
  margin-top: 10px;
`;

const WeatherIcon = styled.img`
  width: 50px;
  height: 50px;
`;

const WeatherInfo = styled.div`
  h3 {
    margin: 0;
    font-size: 1.2rem;
  }
  p {
    margin: 5px 0 0;
  }
`;

const Cardsubjects = styled.div`
color:#3C3D37
font-size:1.2vw;
margin-left:10px;
margin-top:10px;
`

const Cardsubtitle = styled.div`
font-size:1.5vw;
margin-left:10px;
margin-top:20px;
font-weight:600;
margin-bottom:20px;
`

const Popup = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  
`;

const PopupContent = styled.div`
  background-color: white;
  padding: 20px;
  width: 1000px;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  background: #FAF7F0;
`;

const PopupTitle = styled.h3`
  margin-bottom: 10px;
`;

const PopupCloseButton = styled.button`
  margin-top: 20px;
  padding: 10px 20px;
  background-color: #D8D2C2;
  border-radius: 8px;
  color: white;
  border: none;
  cursor: pointer;
  &:hover {
    background-color: #3C3D37;
  }
`;

/* 🔹 가로 스크롤 스타일 */
const ScrollContainer = styled.div`
  display: flex;
  overflow-x: auto;
  gap: 15px;
  padding: 10px;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE, Edge */
  
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari */
  }
`;

/* 🔹 개별 카드 스타일 */
const InfoCard = styled.div`
  min-width: 200px;
  max-width: 250px;
  background: #f8f9fa;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
  padding: 15px;
  text-align: center;
`;

const PlaceTitle = styled.h4`
  margin: 0;
  font-size: 18px;
  font-weight: bold;
`;

const AddressText = styled.p`
  margin: 5px 0 0;
  font-size: 14px;
  color: #555;
`;
const MapContainer = styled.div`
width: 100%;
height: 300px;
background: #ddd;
border-radius: 8px;
`;